export class PageError extends Error {
    attributes: { [key: string]: string | number | boolean };
    constructor(message: any, attributes: { [key: string]: string | number | boolean }) {
      super(message);
      this.name = 'PageError';
      this.attributes = attributes;
    }
  }
  